import { useState, useEffect } from "react";
import Alert from "react-bootstrap/Alert";

function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [networkStatus, setNetworkStatus] = useState("");

  useEffect(() => {
    const connection = navigator.connection;

    // Update online status based on connection type
    const updateNetworkStatus = () => {
      if (connection) {
        const effectiveType = connection.effectiveType;

        if (effectiveType === "2g" || effectiveType === "slow-2g") {
          setNetworkStatus(
            "Weak or unstable network detected. Consider switching to a stronger network."
          );
        } else {
          setNetworkStatus("");
        }
      }
    };

    if (connection) {
      // Listen for changes in connection type
      connection.addEventListener("change", updateNetworkStatus);
    }

    // Initial check
    updateNetworkStatus();

    const handleOnline = () => {
      setIsOnline(true);
    };
    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Periodically check connectivity
    const interval = setInterval(async () => {
      try {
        // Try to fetch a lightweight resource (could be your API or a public site)
        await fetch("/utility/ping", { method: "HEAD", cache: "no-store" });
        setIsOnline(true);
      } catch {
        setIsOnline(false);
      }
    }, 5000); // check every 5 seconds

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(interval);
      if (connection) {
        connection.removeEventListener("change", updateNetworkStatus);
      }
    };
  }, []);

  return { isOnline, networkStatus, setNetworkStatus };
}

export default function NetworkStatus() {
  const { isOnline, networkStatus, setNetworkStatus } = useNetworkStatus();

  return (
    (!isOnline && (
      <Alert
        variant='danger'
        className='fixed-top m-0 d-flex align-items-center'
      >
        <i className='bi bi-wifi-off h-100 fs-1'></i>
        <div className='px-3'>
          <Alert.Heading>Network Error</Alert.Heading>
          <p>
            You are currently offline. Please check your internet connection.
          </p>
        </div>
      </Alert>
    )) ||
    (networkStatus && (
      <Alert
        variant='warning'
        className='fixed-top m-0 d-flex align-items-center '
        onClose={() => setNetworkStatus("")}
        dismissible
      >
        <i className='bi bi-exclamation-triangle h-100 fs-1'></i>
        <div className='px-3'>
          <Alert.Heading>Network Warning</Alert.Heading>
          <p>{networkStatus}</p>
        </div>
      </Alert>
    ))
  );
}
